import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=461bb953&scoped=true"
import script from "./NavbarItem.vue?vue&type=script&lang=js"
export * from "./NavbarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bb953",
  null
  
)

export default component.exports